// StatsWidget.tsx
import React from 'react';
import styled from 'styled-components';

interface StatsWidgetProps {
  total: number;
  zero: number;
  one: number;
  more: number;
  isLoading?: boolean;               // ← new prop
}

// tweak the container to respond to isLoading
const WidgetContainer = styled.div<{ $isLoading: boolean }>`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  /* fade when loading */
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
  pointer-events: ${({ $isLoading }) => ($isLoading ? 'none' : 'auto')};
  transition: opacity 0.3s ease;
`;

interface CardProps {
  $bgColor?: string;
  $textColor?: string;
}

const Card = styled.div<CardProps>`
  flex: 1;
  background: ${({ $bgColor }) => $bgColor || '#fff'};
  border: 1px solid ${({ $bgColor }) => $bgColor || '#ddd'};
  border-radius: var(--border-radius);
  padding: 12px;
  text-align: center;
  box-shadow: var(--shadow);
  color: ${({ $textColor }) => $textColor || 'var(--color-text)'};
`;

const Count = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`;

const Label = styled.div`
  font-size: 0.9rem;
  color: inherit;
`;

function calcoloPercentuale(valore: number, totale: number): string {
  if (totale === 0) return '0%';
  const percentuale = (valore / totale) * 100;
  return `${percentuale.toFixed(0)}%`;
}

const StatsWidget: React.FC<StatsWidgetProps> = ({
  total,
  zero,
  one,
  more,
  isLoading = false,    // ← default
}) => (
  <WidgetContainer $isLoading={isLoading}>
    <Card $bgColor="var(--color-success)" $textColor="#fff">
      <Count>
        {one} su {total} – {calcoloPercentuale(one, total)}
      </Count>
      <Label>OK</Label>
    </Card>

    <Card $bgColor="var(--color-warning)" $textColor="#333">
      <Count>
        {more} su {total} – {calcoloPercentuale(more, total)}
      </Count>
      <Label>Verifica Umana</Label>
    </Card>

    <Card $bgColor="var(--color-error)" $textColor="#fff">
      <Count>
        {zero} su {total} – {calcoloPercentuale(zero, total)}
      </Count>
      <Label>Intervento Necessario</Label>
    </Card>
  </WidgetContainer>
);

export default StatsWidget;